import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import FluigService from "../../../../services/resource/fluigComprasService";
import { Loading } from "../../../../componentes/loading/loading";

export default function ResumoPorFilialPrioridade({ dataInicial, dataFinal, filtrar, openModal }) {
  const service = new FluigService();
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    service
      .resumoPorPrioridadeFilial(dataInicial, dataFinal)
      .then((response) => {
        const data = response?.data ?? [];

        const filiais = [...new Set(data.map(item => item.filial))];
        const prioridades = [...new Set(data.map(item => item.prioridade))];

        const series = prioridades.map(prioridade => ({
          name: prioridade,
          data: filiais.map(filial => {
            const item = data.find(d => d.filial === filial && d.prioridade === prioridade);
            return item ? item.totalSolicitacoes : 0;
          }),
        }));

        // ⚠️ use as variáveis locais diretamente dentro do evento
        const options = {
          chart: {
            type: "bar",
            events: {
              dataPointSelection: (event, chartContext, config) => {
                const filial = filiais[config.dataPointIndex];
                const prioridade = series[config.seriesIndex]?.name;
                if (filial && prioridade) {
                  openModal(filial, "filial", "prioridade", prioridade);
                }
              },
            },
          },
          xaxis: {
            categories: filiais,
          },
          legend: {
            position: "top",
          },
          tooltip: {
            y: {
              formatter: (val) => `: ${val}`,
            },
          },
          colors: prioridades.map(prioridade =>
            prioridade === "emergencial" ? "#eb2323ff" :
            prioridade === "alta" ? "#e9e635ff" :
            prioridade === "moderada" ? "#4b5ae0ff" :
            prioridade === "baixa" ? "#51f63bff" :
            "#4b5ae0ff"
          ),
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "70%",
              borderRadius: 4,
            },
          },
          dataLabels: {
            enabled: true,
          },
        };

        setChartOptions(options);
        setChartSeries(series);
      })
      .catch((err) => console.error("Erro ao buscar API:", err))
      .finally(() => setLoading(false));
  }, [filtrar]);

  return (
    <div className="bg-card border border-border rounded-lg shadow-card p-4 h-96 w-full">
      <h3 className="text-lg font-display font-semibold text-foreground mb-1">
        Solicitações por Filial e Prioridade
      </h3>
      <label className="text-muted-foreground text-sm">
        Distribuição das solicitações entre as unidades da empresa por prioridade.
      </label>

      <div className="h-64 w-full">
        {!loading && chartSeries.length > 0 ? (
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="bar"
            height="100%"
            width="100%"
          />
        ) : !loading ? (
          "Não existem dados disponíveis para o intervalo selecionado."
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
}
